export const ORANGE_MESSAGE_DEFAULT = 'Un problème technique ne permet pas d’accéder au service que vous désirez. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez #USER_CODE dans le moteur de recherche. Code erreur : #USER_CODE-#CODE';
export const ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE = 'Accès au service momentanément indisponible';
export const ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE = 'Accès au programme momentanément indisponible';

export const ORANGE_CDN_IDENTIFIER = 'cdn.orange';

export const replaceCodes = (userCode, code) => ORANGE_MESSAGE_DEFAULT.replaceAll('#USER_CODE', userCode).replaceAll('#CODE', code);

export const detectErrorWithPattern = ({ access: { url } }) => {
  const { host, pathname } = new URL(url);
  const pattern = /^(\/[a-z]{3,}\/[a-z0-9]{1}\/[a-z0-9]{2})?\/[a-z0-9]{10,}/;
  return host.includes(ORANGE_CDN_IDENTIFIER) && !pattern.test(pathname);
};

export const DEFAULT_ORANGE_ERROR = {
  orangeErrorCode: null,
  orangeUserCode: null,
  orangeMessage: ORANGE_MESSAGE_DEFAULT,
  orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
};

/* 1000 Gateway Call Errors */
export const ORANGE_ERRORS_MAP = [
  {
    codes: [1000],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1000),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1001],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1001),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1002],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1002),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1003],
    canRetry: true,
    fatal: true,
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1003),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1004],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1004),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1005],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1005),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [1008],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: replaceCodes('H09', 1008),
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  /* 2000 */
  {
    codes: [2000],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au service que vous désirez. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2000',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2001],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Cette vidéo est déconseillée aux moins de 16 ans. Elle sera disponible entre 22h30 et 5h00.<br /> Code erreur : H09-2001',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2002],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Cette vidéo est déconseillée aux moins de 18 ans. Elle sera disponible entre 22h30 et 5h00.<br />Code erreur : H09-2002',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2003],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Cette vidéo n\'est malheureusement plus disponible.<br/> Code erreur : H09-2003',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2004],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Cette vidéo sera bientôt disponible. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche. <br />Code erreur : H09-2004',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2005],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Ce direct commencera le JJ/MM/AAAA à HHhMM.  Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2005',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2006],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Ce direct sera bientôt disponible.  Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2006',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2007],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Ce direct est terminé.<br />Code erreur : H09-2007',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2008],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: '#MESSAGE Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2008',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2009],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: '#MESSAGE<br />Code erreur : H09-2009',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2010],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'L\'accès à cette vidéo est incompatible avec votre configuration. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2010',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2012],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: 'Cette vidéo n\'est malheureusement pas disponible.<br />Code erreur : H09-2012',
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  {
    codes: [2013],
    orangeErrorCode: 51,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-2013',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [2015],
    orangeErrorCode: 53,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-2015',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [2023],
    orangeErrorCode: 99,
    orangeUserCode: 'H09',
    orangeMessage: `L'accès à cette vidéo est momentanément indisponible. Merci de réessayer ultérieurement.
    <br />Si le problème persiste, rendez-vous sur orange.fr , rubrique assistance, tapez H09 dans le moteur de recherche.<br />Code erreur : H09-2008`,
    orangeTitle: ORANGE_MESSAGE_TITLE_SERVICE_UNAVAILABLE
  },
  /* 3000 Access Errors */
  {
    codes: [3000],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3000',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [3001],
    orangeErrorCode: 51,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3001',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 3X02 */
  {
    codes: [3102, 3202, 3302],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3X02',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 3003 */
  {
    codes: [3003],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3X02',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 3X04 */
  {
    codes: [3104, 3204, 3304],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Il semblerait que vous soyez dans une zone où nous n\'avons pas les droits de diffusion.',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [3005],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3005',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [3006],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [3007],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3007',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [3008],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3008',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 3X10 */
  {
    codes: [3110, 3210, 3310],
    orangeErrorCode: 50,
    orangeUserCode: 'H03',
    orangeMessage: 'L\'utilisation d\'un VPN ou d\'un proxy a été détectée. Merci de le désactiver pour accéder à cette vidéo.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-3X10',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 4X12 */
  {
    codes: [4112, 4212, 4312],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'L\'utilisation d\'un VPN ou d\'un proxy a été détectée. Veuillez le désactiver pour accéder à cette vidéo.<br />Code erreur : H03-4X12',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 4X00 Renderer Errors */
  {
    codes: [4100, 4200, 4300],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X00',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X01
  {
    codes: [4101, 4201, 4301],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X01',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X02
  {
    codes: [4102, 4202, 4302],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X02',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X03
  {
    codes: [4103, 4203, 4303],
    orangeErrorCode: 53,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X03',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X04
  {
    codes: [4104, 4204, 4304],
    orangeErrorCode: 52,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X04',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X05
  {
    codes: [4105, 4205, 4305],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X05',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X06
  {
    codes: [4106, 4206, 4306],
    orangeErrorCode: 52,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X06',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X07
  {
    codes: [4107, 4207, 4307],
    orangeErrorCode: 52,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X07',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X08
  {
    codes: [4108, 4208, 4308],
    orangeErrorCode: 53,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X08',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  // 4X09
  {
    codes: [4109, 4209, 4309],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X09',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [4110, 4210, 4310],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Un problème technique ne permet pas d’accéder au programme que vous souhaitez visionner. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X10',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  /* 4X11 */
  {
    codes: [4111, 4211, 4311],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Il semblerait que vous soyez dans une zone où nous n\'avons pas les droits de diffusion. Merci de réessayer ultérieurement.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-4X11',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  },
  {
    codes: [5000],
    orangeErrorCode: 40,
    orangeUserCode: 'H03',
    orangeMessage: 'Une erreur est survenue lors de la lecture de la vidéo. Merci de réessayer.<br />Si le problème persiste, rendez-vous sur orange.fr, rubrique assistance, tapez H03 dans le moteur de recherche.<br />Code erreur : H03-5000',
    orangeTitle: ORANGE_MESSAGE_TITLE_PROGRAM_UNAVAILABLE
  }
];

export const replaceHashTagWithMessage = (error, message = '') => {
  const MESSAGE = '#MESSAGE';

  return ({
    ...error,
    ...(error.orangeMessage ? { orangeMessage: error.orangeMessage.replace(MESSAGE, message) } : {})
  });
};
